import Vue from 'vue'
import VueRouter from 'vue-router'
import index from "../views/index.vue"
import download from "../views/download.vue"
import error from "@/views/error.vue";
import p from "@/views/p.vue";

Vue.use(VueRouter)
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: index,
  },
  {
    path: '/download',
    name: 'download',
    component: download,
  },
  {
    path: '/p',
    name: 'p',
    component: p,
  },
  {
    path: '/error',
    name: 'error',
    component: error,
  },
]

/**
 * 挂载导航守卫，简单的讲，判断是否可以访问目标页面
 *  to 将要访问的路径
 *  from代表从哪个页面跳转过来的
 *  next 是一个函数 表示放行， next('/login') 强制跳转
 */

/*router.beforeEach((to, from, next) => {

})*/

export default new VueRouter({
  mode: 'history',
  base: '/',
  routes
})
